<template>
  <div>
    <el-form ref="EditForm" :model="EditForm" label-width="110px" style="margin-top:10px;margin-bottom:60px;" :rules="EditRules">
        <el-row type="flex" class="row-bg">
          <el-col :span="14">
            <el-form-item label="名称" prop="c_name">
                <el-input v-model="EditForm.c_name"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" class="row-bg">
          <el-col :span="14">
            <el-form-item label="简介" prop="c_introduce">
                <el-input type="textarea" v-model="EditForm.c_introduce" :rows="3"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" class="row-bg">
          <el-col :span="7">
                <el-form-item label="代码" prop="c_code">
                    <el-input v-model="EditForm.c_code"></el-input>
                </el-form-item>
          </el-col>
          <!-- <el-col :span="7">
            <el-form-item label="类型" prop="c_type">
                <el-radio v-model="EditForm.c_type" label="0">资讯</el-radio>
                <el-radio v-model="EditForm.c_type" label="1">活动</el-radio>
                <el-radio v-model="EditForm.c_type" label="2">攻略</el-radio>
            </el-form-item>
          </el-col> -->
          <!-- <el-col :span="7">
            <el-form-item label="状态" prop="c_status">
                <el-radio v-model="EditForm.c_status" label="0">未发布</el-radio>
                <el-radio v-model="EditForm.c_status" label="1">已发布</el-radio>
            </el-form-item>
          </el-col> -->
        </el-row>
        <el-row type="flex" class="row-bg">
          <!-- <el-col :span="7">
            <el-form-item label="是否有子栏目" prop="c_haschild">
                <el-radio v-model="EditForm.c_haschild" label="0">否</el-radio>
                <el-radio v-model="EditForm.c_haschild" label="1">是</el-radio>
            </el-form-item>
          </el-col> -->
          <el-col :span="7">
            <el-form-item label="页面" prop="c_single">
                <el-radio v-model="EditForm.c_single" label="0">单页面</el-radio>
                <el-radio v-model="EditForm.c_single" label="1">列表</el-radio>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" class="row-bg">
          <el-col :span="7">
            <el-form-item label="专题" prop="c_topic">
                <el-select v-model="EditForm.c_topic" placeholder="请选择">
                <el-option
                    v-for="item in topicOptions"
                    :key="item.t_id"
                    :label="item.t_name"
                    :value="item.t_id">
                </el-option>
                </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" class="row-bg">
          <el-col :span="7">
            <el-form-item label="所属栏目" prop="c_fid">
                <el-cascader
                    v-model="selectedEditOptions"
                    clearable
                    change-on-select
                    :options="parentEditOptions"
                    @focus="getEditCategory"
                    @change="onProvincesEditChange"
                    :props="parentEditProps"
                    placeholder="此项不选择表示建立顶级栏目"
                    >
                </el-cascader>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="栏目负责人" prop="c_director">
                <el-select v-model="EditForm.c_director" multiple placeholder="请选择">
                <el-option
                    v-for="item in selectAdminOptions"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                </el-option>
                </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" class="row-bg">
          <!-- <el-col :span="7">
            <el-form-item label="排序值" prop="c_sort">
                <el-input v-model="EditForm.c_sort"></el-input>
            </el-form-item>
          </el-col> -->
          <!-- <el-col :span="7">
            <el-form-item label="代码" prop="c_code">
                <el-input v-model="EditForm.c_code"></el-input>
            </el-form-item>
          </el-col> -->
        </el-row>
        <el-row type="flex" class="row-bg">
          <el-col :span="14">
            <el-form-item label="链接" prop="c_url">
                <el-input v-model="EditForm.c_url"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" class="row-bg">
          <el-col :span="14">
            <el-form-item label="图标" prop="c_icon">
            <el-upload
                :class="{disabled:uploadDisabledIcon}"
                :action="uploadAddress"
                list-type="picture-card"
                name="file"
                :limit="1"
                ref="EditUploadIcon"
                :http-request="customUploadIcon"
                :before-upload="beforeUploadIcon"
                :on-preview="handleAddPreviewIcon"
                :on-remove="removeEditUploadIcon"
                :file-list="EditFileListIcon">
                <i class="el-icon-plus"></i>
            </el-upload>
                <!-- :on-success="successEditUploadIcon" -->
            <p style="margin:0;color:red">图片格式：".bmp", ".jpg", ".jpeg", ".png"</p>
            <el-dialog :visible.sync="AddPreviewDialogVisibleIcon">
              <img width="100%" :src="AddPreviewDialogImageUrlIcon" alt="">
            </el-dialog>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" class="row-bg">
          <el-col :span="14">
            <el-form-item label="封面图" prop="c_cover">
            <el-upload
                :class="{disabled:uploadDisabledCover}"
                :action="uploadAddress"
                list-type="picture-card"
                name="file"
                :limit="1"
                ref="EditUpload"
                :http-request="customUploadCover"
                :before-upload="beforeUploadCover"
                :on-preview="handleAddPreviewCover"
                :on-remove="removeEditUploadCover"
                :file-list="EditFileListCover">
                <i class="el-icon-plus"></i>
            </el-upload>
                <!-- :on-success="successEditUploadCover" -->
            <p style="margin:0;color:red">图片格式：".bmp", ".jpg", ".jpeg", ".png"</p>
            <el-dialog :visible.sync="AddPreviewDialogVisibleCover">
              <img width="100%" :src="AddPreviewDialogImageUrlCover" alt="">
            </el-dialog>
            </el-form-item>
          </el-col>
        </el-row>   
      </el-form>

      <el-footer>
        <el-button type="primary" @click="goBack" size="small" icon="el-icon-arrow-left">返回</el-button>
        <el-button type="primary" @click="editSave('EditForm')" size="small" icon="el-icon-edit-outline">保存</el-button>
      </el-footer>
  </div>
</template>

<script>
// 引入接口
import api from '@/api/api.js'
// 获取token
import { getToken , removeToken } from '@/utils/auth'

export default {
  name: 'componentspage1',
  data() {
      return {
          EditForm : {
              // c_haschild : '',
              c_name : '',
              c_type : '',
              c_amount : '',
              c_id : '',
              c_director : [],
              c_article : '',
              c_single : '',
              c_fid : '',
              // c_sort : '',
              c_sub : '',
              c_topic : '',
              c_url : '',
              c_code : '',
              c_status : '',
              c_level : '',
              c_route : '',
              c_icon : '',
              c_cover : '',
              c_introduce: ''
            },
            
            EditRules : {
              c_name : [{required: true,message : '请输入名称', trigger: 'blur'}],
              c_topic : [{required: true,message : '请选择专题', trigger: 'change'}],
            //   c_fid : [{required: true,message : '请输入所属栏目', trigger: 'blur'}],
              c_single : [{required: true,message : '请选择页面类型', trigger: 'change'}],
          },

            EditFileListIcon : [],
            EditFileListCover : [],

            selectAdminOptions : [], // 栏目负责人
            topicOptions : [] , // 专题数组，遍历后可获取专题ID
            parentEditOptions : [] , // 父级选择框
            parentEditProps : {
              value: 'c_id',
              label:'c_name',
              children: 'c_children'
            },

            selectedEditOptions : [],

            uploadAddress : `${api.dev}/p/main/upload/image`,  // 上传图片的地址

            AddPreviewDialogVisibleCover : false,
            AddPreviewDialogImageUrlCover : '',
            AddPreviewDialogVisibleIcon : false,
            AddPreviewDialogImageUrlIcon : '',
      }
  },
  methods : {
      goBack() {
        this.$router.back(-1);
      },
      getInfo() {
          this.$http.get(`${api.dev}/p/main/category/select`,{params : {access_token : getToken() , c_id : this.$route.params.id}}).then(res => {
                if(res.body.code == 200) {
                    // this.EditForm.c_haschild = (res.body.content.category.c_haschild).toString();
                    this.EditForm.c_name = res.body.content.category.c_name;
                    // this.EditForm.c_type = (res.body.content.category.c_type).toString();
                    this.EditForm.c_amount = res.body.content.category.c_amount;
                    this.EditForm.c_id = res.body.content.category.c_id;
                    this.EditForm.c_director = res.body.content.category.c_director;
                    this.EditForm.c_article = res.body.content.category.c_article;
                    this.EditForm.c_single = (res.body.content.category.c_single).toString();
                    this.EditForm.c_fid = res.body.content.category.c_fid;
                    // this.EditForm.c_sort = res.body.content.category.c_sort;
                    this.EditForm.c_sub = res.body.content.category.c_sub;
                    this.EditForm.c_topic = res.body.content.category.c_topic;
                    this.EditForm.c_url = res.body.content.category.c_url;
                    this.EditForm.c_code = res.body.content.category.c_code;
                    // this.EditForm.c_status = (res.body.content.category.c_status).toString();
                    this.EditForm.c_level = res.body.content.category.c_level;
                    this.EditForm.c_route = res.body.content.category.c_route;
                    this.EditForm.c_icon = res.body.content.category.c_icon;
                    this.EditForm.c_cover = res.body.content.category.c_cover;
                    this.EditForm.c_introduce = res.body.content.category.c_introduce;

                    this.getEditCategory();
                    this.selectedEditOptions = [this.EditForm.c_id]  // 所属栏目的父级ID
                    // this.selectedEditOptions = [20,21]  // 所属栏目的父级ID

                    if(this.EditForm.c_icon) {
                        this.EditFileListIcon = [{url: `${api.address}${res.body.content.category.c_icon}`}];
                    }
                    if(this.EditForm.c_cover) {
                        this.EditFileListCover = [{url: `${api.address}${res.body.content.category.c_cover}`}];
                    }
                }else if(res.body.code == 500) {
                    this.$message({
                        message: res.body.msg,
                        type: 'error'
                    });
                    removeToken();
                    setTimeout(function () {
                        this.$router.push({path: '/login'});
                    },2000)
                }
            })
      },
      // 获取所有专题
      getAllTopic() {
          this.$http.get(`${api.dev}/p/main/drop/selectTopic`,{params : {access_token : getToken()}}).then(res => {
              if(res.body.code == 200) {
                //   this.topicMsg = res.body.content;
                  this.topicOptions = res.body.content;
              }else if(res.body.code == 500) {
                  this.$message({
                    message: res.body.msg,
                    type: 'error'
                  });
                  removeToken();
                  setTimeout(function () {
                    this.$router.push({path: '/login'});
                  },2000)
              }
          })
      },
      // 获取栏目负责人
      getSelectAdmin() {
        this.$http.get(`${api.dev}/p/main/drop/selectAdmin`,{params: {access_token: getToken(), type : 0}}).then(res => {
          if(res.body.code == 200) {
            this.selectAdminOptions = res.body.content;
          }else if(res.body.code == 500) {
            this.$message({
              message: res.body.msg,
              type: 'error'
            });
            removeToken();
            setTimeout(function () {
              this.$router.push({path: '/login'});
            },2000)
          }
        })
      },
      getEditCategory(e) {
        this.$http.get(`${api.dev}/p/main/category/show`,{params: {access_token:getToken(),c_topic:this.EditForm.c_topic}}).then(res => {
            if(res.body.code == 200) {
                this.parentEditOptions = res.body.content;
                // console.log('getEditCategory');
                // console.log(this.parentEditOptions);
                // console.log('selectedEditOptions');
                // console.log(this.selectedEditOptions);
            }else if(res.body.code == 500) {
            this.$message({
                message: res.body.msg,
                type: 'error'
            });
            removeToken();
            setTimeout(function () {
                this.$router.push({path: '/login'});
            },2000)
            }
        })
    },
    // 编辑时选择父级ID
    onProvincesEditChange(item) {
      for(var i = 0 ; i < item.length ; i++) {
            if(i == item.length - 1) {
                this.EditForm.c_fid = item[i];
            }
        }
      if(item.length == 0) {
        this.EditForm.c_fid = '';
      }
    },
    editSave(formName) {
        this.$refs[formName].validate((valid) => {
            if(valid) {
                const loading = this.$loading({
                    lock: true,
                    text: '正在保存中...',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                var formdata = new FormData();
                formdata.append('access_token',getToken());
                // formdata.append('c_haschild',this.EditForm.c_haschild);
                formdata.append('c_name',this.EditForm.c_name);
                // formdata.append('c_type',this.EditForm.c_type);
                formdata.append('c_id',this.EditForm.c_id);
                formdata.append('c_director',JSON.stringify(this.EditForm.c_director));
                formdata.append('c_single',this.EditForm.c_single);
                // formdata.append('c_sort',this.EditForm.c_sort);
                formdata.append('c_topic',this.EditForm.c_topic);
                formdata.append('c_url',this.EditForm.c_url);
                formdata.append('c_code',this.EditForm.c_code);
                // formdata.append('c_status',this.EditForm.c_status);
                formdata.append('c_icon',this.EditForm.c_icon);
                formdata.append('c_cover',this.EditForm.c_cover);
                formdata.append('c_introduce',this.EditForm.c_introduce);
                
                if(this.EditForm.c_fid) {
                    formdata.append('c_fid',this.EditForm.c_fid);
                    formdata.append('c_level',this.selectedEditOptions.length + 1);
                }else {
                    formdata.append('c_fid',0);
                    formdata.append('c_level',1);
                }

                this.$http.post(`${api.dev}/p/main/category/update`,formdata,{emulateJSON: true}).then(res => {
                    if(res.body.code == 200) {
                        loading.close();
                        this.$message({
                            message: res.body.msg,
                            type: 'success'
                        });
                        this.$router.back(-1);
                    }else if (res.body.code == 500) {
                        loading.close();
                        this.$message({
                            message : res.body.msg,
                            type : 'error'
                        })
                    }
                })
            }else {
                console.log('submit error');
                return false;
            }
        })
    },
    customUploadIcon(options){   
        const formdata = new FormData();
        formdata.append('file', options.file);
        // 添加其他参数
        formdata.append('access_token', getToken());    
        this.$http.post(options.action,formdata,{emulateJSON:true}).then(res => {        
                if(res.body.code==500 || res.body.code==510)
                {   this.$refs.EditUploadIcon.uploadFiles.splice(this.$refs.EditUploadIcon.uploadFiles.indexOf(), 1);//移除预览文件
                  this.$message({
                            message: res.body.msg,
                            type: 'error'
                        });
                    return false;
                }
                else
                {
                  this.EditForm.c_icon= res.body.content; 
                }  
        });       
      },
    // successEditUploadIcon(res,file,fileList) {
    //         this.EditForm.c_icon = res.content;
    //   },
      removeEditUploadIcon(file,fileList) {
            this.EditForm.c_icon = '';
      },
      customUploadCover(options){  
        //console.log(options);
        const formdata = new FormData();
        formdata.append('file', options.file);
        // 添加其他参数
        formdata.append('access_token', getToken());    
        this.$http.post(options.action,formdata,{emulateJSON:true}).then(res => {        
                if(res.body.code==500 || res.body.code==510)
                {   this.$refs.EditUpload.uploadFiles.splice(this.$refs.EditUpload.uploadFiles.indexOf(), 1);//移除预览文件
                  this.$message({
                            message: res.body.msg,
                            type: 'error'
                        });
                    return false;
                }
                else
                {
                  this.EditForm.c_cover  = res.body.content; 
                }  
        });       
      },
      // successEditUploadCover(res,file,fileList) {
      //       this.EditForm.c_cover = res.content;
      // },
      removeEditUploadCover(file,fileList) {
            this.EditForm.c_cover = '';
      },
      beforeUploadIcon(file) {
        const isLt5M = file.size / 1024 / 1024  < 5;
        if (['image/jpg', 'image/jpeg', 'image/bmp','image/png'].indexOf(file.type) == -1) {
            this.$message.error('请上传正确的图片格式');
            return false;
        }
        if (!isLt5M) {
            this.$message.error('上传图片大小不能超过5MB!');
            return false;
        }
      },
      beforeUploadCover(file) {
        const isLt5M = file.size / 1024 / 1024  < 5;
        if (['image/jpg', 'image/jpeg', 'image/bmp','image/png'].indexOf(file.type) == -1) {
            this.$message.error('请上传正确的图片格式');
            return false;
        }
        if (!isLt5M) {
            this.$message.error('上传图片大小不能超过5MB!');
            return false;
        }
      },
            // 放大图片
    handleAddPreviewCover(file) {
        this.AddPreviewDialogVisibleCover = true;
        this.AddPreviewDialogImageUrlCover = file.url;
    },
    handleAddPreviewIcon(file) {
        this.AddPreviewDialogVisibleIcon = true;
        this.AddPreviewDialogImageUrlIcon = file.url;
    }
  },
  created() {
      this.getInfo()
      this.getAllTopic()
      this.getSelectAdmin()
  },
  computed: {
        uploadDisabledIcon:function() {
            return this.EditForm.c_icon
        },
        uploadDisabledCover:function() {
            return this.EditForm.c_cover
        },
    },
}
</script>

<style lang="stylus" scoped>
.el-footer 
    background-color #A3C0D1;
    color #333;
    line-height 60px;
    position absolute;
    width 100%;
    bottom 0;
    z-index 9999
    margin-left -15px
    margin-right -15px
form.el-form 
    width 1180px;
</style>

